var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 408.05,
    height: 54.39,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 408.05 54.39",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_3);}.cls-2{fill:#f4d018;}.cls-3{fill:#411564;}.cls-4{fill:url(#Unbenannter_Verlauf_4);}.cls-5{fill:url(#Unbenannter_Verlauf);}.cls-6{fill:url(#Unbenannter_Verlauf_2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf",
    x1: 37.01,
    y1: -1160.33,
    x2: 37.01,
    y2: -1214.72,
    gradientTransform: "translate(.04 -1160.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#955eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8551a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6d3b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#592a7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4b1e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#431766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#411564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#411564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c155e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2f154d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: -7731.27,
    y1: -1160.33,
    x2: -7731.27,
    y2: -1214.72,
    gradientTransform: "translate(-7620.2 -1160.35) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff0ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#feecb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fce68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fae065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f9db46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f8d72c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f7d418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f6d20b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f6d002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f6d000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f6d000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f6d000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#f6cd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f6c200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6b200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    x1: 39.1,
    y1: -1170.13,
    x2: 39.1,
    y2: -1187.73,
    gradientTransform: "translate(.04 -1160.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6d000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    x1: 109.12,
    y1: -1169.88,
    x2: 109.12,
    y2: -1204.99,
    gradientTransform: "translate(.04 -1160.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#955eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8550a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#67368b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#522475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#451968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#411564"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.1,52.95l-4.63-10.77c-.26-.6-.26-1.29-.01-1.89l4.67-11.2c.26-.63-.2-1.33-.89-1.33h-104.26v26.54h104.25c.69,0,1.16-.71.88-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.7,48.7v-12.52l-2.91,1.3v-1.74l3.35-1.79h1.57v14.76h-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.21,48.92c-2.01,0-4.7-.85-4.7-7.6s2.88-7.6,4.7-7.6,4.7.67,4.7,7.6-2.68,7.6-4.7,7.6ZM184.21,35.28c-1.45,0-2.68.58-2.68,6.04s1.63,6.04,2.68,6.04c1.14,0,2.68-.65,2.68-6.04s-1.25-6.04-2.68-6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.08,48.92c-.78,0-1.61-.18-2.35-.38v-1.7c.65.16,1.43.34,2.08.34.94,0,1.27-.4,1.27-1.63v-12.5h2.01v12.86c0,2.3-1.23,3.02-3.02,3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.44,48.7l-.83-3.49h-5.14l-.83,3.49h-2.19l4.32-15.65h2.55l4.32,15.65h-2.19ZM210.85,37.79c-.36-1.52-.63-2.64-.8-3.47-.18.83-.42,1.95-.8,3.47l-1.39,5.68h4.38l-1.39-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.92,48.7v-7.65h-5.59v7.65h-2.01v-15.65h2.01v6.26h5.59v-6.26h2.01v15.65h-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.16,48.7l-1.14-3.56c-.4-1.25-.89-2.41-1.63-3.09-.65.09-1.3.11-1.97.16v6.48h-2.01v-15.65h3.29c3.06,0,5.66.56,5.66,4.4,0,2.46-1.27,3.64-3.06,4.2.67.58,1.12,1.36,1.56,2.55l1.72,4.49h-2.42ZM235.31,34.86h-.89v5.72c3.64-.11,4.92-.83,4.92-3.13,0-2.48-1.45-2.59-4.02-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.7,48.7v-15.65h7.6v1.88h-5.59v4.38h5.14v1.74h-5.14v5.77h5.59v1.88h-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.4,22.92h-3.1l-5.09-19.36h2.9l2.77,13c.39,1.91.91,4.81.97,5.09.03-.14.55-3.15.97-5.09l2.77-13h2.9l-5.09,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.53,22.92V3.57h9.4v2.32h-6.91v5.42h6.36v2.16h-6.36v7.14h6.91v2.32h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.16,22.92l-1.41-4.4c-.5-1.55-1.11-2.99-2.02-3.82-.8.11-1.6.14-2.43.19v8.02h-2.49V3.57h4.07c3.79,0,7,.69,7,5.45,0,3.04-1.58,4.51-3.79,5.2.83.72,1.38,1.69,1.94,3.15l2.13,5.56h-2.99ZM196.4,5.81h-1.11v7.08c4.51-.14,6.08-1.02,6.08-3.87,0-3.07-1.8-3.21-4.98-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.02,22.92V3.57h9.4v2.32h-6.91v5.42h6.36v2.16h-6.36v7.14h6.91v2.32h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.3,22.92V3.57h2.54v19.36h-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.8,22.92l-5.12-10.54c-1.25-2.57-2.21-5.2-2.21-5.2,0,0,.39,3.73.39,5.81v9.93h-2.49V3.57h2.46l4.87,10.12c1.16,2.41,2.13,5.14,2.21,5.39-.03-.17-.41-3.93-.41-6V3.57h2.49v19.36h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.98,23.2c-1.27,0-2.49-.25-3.65-.58v-2.27c1.13.33,2.6.66,3.6.66,1.85,0,3.4-.58,3.4-3.1,0-1.71-.97-2.57-2.24-3.43l-1.99-1.36c-1.58-1.08-2.96-2.52-2.96-4.78,0-3.9,3.07-5.06,5.61-5.06,1.24,0,2.38.25,3.32.64v2.18c-1.13-.41-2.3-.69-3.32-.69-1.91,0-3.18.69-3.18,2.71,0,1.44,1,2.24,2.21,3.1l1.55,1.08c1.74,1.22,3.48,2.6,3.48,5.42,0,4.65-2.82,5.48-5.84,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.85,22.92h-3.24l-2.74-13.16c-.39-1.85-.86-4.62-.88-4.9-.03.14-.53,2.99-.91,4.9l-2.77,13.16h-3.21l-3.62-19.36h2.88l1.74,13.08c.22,1.66.55,4.78.58,4.95.03-.17.5-3.29.86-4.95l2.77-13.08h3.4l2.71,13.08c.33,1.6.8,4.59.86,4.95.03-.17.41-3.32.64-4.95l1.71-13.08h2.88l-3.65,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.82,22.92V3.57h9.4v2.32h-6.91v5.42h6.36v2.16h-6.36v7.14h6.91v2.32h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M302.95,5.92h-4.42v17.01h-2.49V5.92h-4.7v-2.35h11.89l-.28,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.29,5.92h-4.42v17.01h-2.49V5.92h-4.7v-2.35h11.89l-.28,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.01,22.92h-3.24V3.57h3.51c4.73,0,7.27.75,7.27,5.03,0,2.46-1.66,3.87-3.32,4.26,2.07.3,3.87,1.44,3.87,4.54,0,5.12-3.01,5.53-8.1,5.53ZM320.23,5.58h-.97v6.42h1.02c3.4,0,4.78-.55,4.78-3.32s-1.52-3.1-4.84-3.1ZM320.29,13.94h-1.02v6.97h1.22c3.46,0,5.14-.44,5.14-3.51s-2.02-3.46-5.34-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332.82,22.92V3.57h9.4v2.32h-6.91v5.42h6.36v2.16h-6.36v7.14h6.91v2.32h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.25,22.92h-3.24l-2.74-13.16c-.39-1.85-.86-4.62-.88-4.9-.03.14-.53,2.99-.91,4.9l-2.77,13.16h-3.21l-3.62-19.36h2.88l1.74,13.08c.22,1.66.55,4.78.58,4.95.03-.17.5-3.29.86-4.95l2.77-13.08h3.4l2.71,13.08c.33,1.6.8,4.59.86,4.95.03-.17.41-3.32.64-4.95l1.71-13.08h2.88l-3.65,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.22,22.92V3.57h9.4v2.32h-6.91v5.42h6.36v2.16h-6.36v7.14h6.91v2.32h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.85,22.92l-1.41-4.4c-.5-1.55-1.11-2.99-2.02-3.82-.8.11-1.6.14-2.43.19v8.02h-2.49V3.57h4.07c3.79,0,7,.69,7,5.45,0,3.04-1.58,4.51-3.79,5.2.83.72,1.38,1.69,1.94,3.15l2.13,5.56h-2.99ZM385.1,5.81h-1.11v7.08c4.51-.14,6.08-1.02,6.08-3.87,0-3.07-1.8-3.21-4.98-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.95,22.92h-3.24V3.57h3.51c4.73,0,7.27.75,7.27,5.03,0,2.46-1.66,3.87-3.32,4.26,2.07.3,3.87,1.44,3.87,4.54,0,5.12-3.01,5.53-8.1,5.53ZM400.17,5.58h-.97v6.42h1.02c3.4,0,4.78-.55,4.78-3.32s-1.52-3.1-4.84-3.1ZM400.23,13.94h-1.02v6.97h1.22c3.46,0,5.14-.44,5.14-3.51s-2.02-3.46-5.34-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.12,0H9.34C4.19.01.02,4.18,0,9.34v35.72c.02,5.15,4.19,9.32,9.34,9.34h64.77V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.11,0h64.78c5.15.01,9.32,4.18,9.34,9.34v35.72c-.01,5.15-4.18,9.32-9.34,9.34h-64.78V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.99,44.17l-7.65-14.72,6.69-10.78h-7.74l-5.68,11.06,6.62,14.44h7.76ZM55.07,9.54h-6.72v34.64h6.74V9.54ZM42.35,31.42c.13-2.25-.16-4.51-.84-6.67-.5-1.52-1.34-2.9-2.45-4.04-.94-.94-2.11-1.63-3.39-2-1.19-.35-2.42-.52-3.66-.53-1.3,0-2.6.19-3.85.55-1.3.4-2.49,1.11-3.46,2.07-1.14,1.14-2,2.52-2.52,4.05-.71,2.12-1.04,4.35-.97,6.59-.09,2.4.28,4.79,1.11,7.05.59,1.55,1.56,2.92,2.82,4,1.1.9,2.4,1.51,3.8,1.78,1.34.27,2.7.4,4.07.41.97-.01,1.95-.08,2.91-.22.95-.13,1.78-.28,2.5-.46s1.5-.39,2.34-.65v-5.35c-1,.26-1.87.48-2.63.65s-1.58.33-2.5.46c-.88.13-1.78.19-2.67.19-.57,0-1.13-.07-1.68-.19-.58-.13-1.12-.39-1.58-.77-.55-.46-.98-1.04-1.25-1.71-.38-.96-.57-1.98-.55-3.01h14.42l.05-2.21ZM27.87,29.4c.03-2.54.36-4.31,1.01-5.32.69-1.04,1.89-1.62,3.13-1.51.55,0,1.1.09,1.61.28.49.22.9.59,1.15,1.06.35.65.58,1.35.69,2.07.18,1.12.28,2.26.29,3.4l-7.88.02ZM15.03,9.54h-6.74v34.64h6.74V9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.85,18.48c-.94-.18-1.89-.28-2.84-.29-.72-.02-1.43.15-2.07.48-.54.28-1.04.63-1.49,1.04-.47.45-.89.96-1.23,1.51l-.86-2.55h-5.39v25.5h6.74v-18.86c.16-.09.33-.18.5-.24.3-.12.69-.27,1.25-.43.49-.15,1-.24,1.51-.24.55,0,1.1.05,1.64.12.64.08,1.15.17,1.54.24.23.06.46.1.69.12v-6.4ZM121.65,31.42c.12-2.26-.17-4.52-.86-6.67-.5-1.51-1.34-2.89-2.45-4.04-.95-.94-2.11-1.63-3.4-2-1.19-.35-2.42-.52-3.67-.53-1.3,0-2.6.19-3.85.55-1.3.4-2.49,1.11-3.46,2.07-1.13,1.14-2,2.52-2.52,4.05-.71,2.12-1.04,4.35-.97,6.59-.08,2.39.3,4.77,1.12,7.02.58,1.54,1.53,2.91,2.77,4,1.1.9,2.4,1.51,3.8,1.78,1.34.27,2.7.4,4.07.41.99,0,1.98-.06,2.96-.19.95-.13,1.78-.28,2.5-.46s1.5-.39,2.34-.65v-5.35c-1,.26-1.87.48-2.63.65s-1.58.33-2.5.46c-.89.13-1.78.19-2.68.19-.57,0-1.13-.07-1.68-.19-.59-.13-1.14-.39-1.61-.77-.55-.46-.98-1.04-1.25-1.71-.38-.96-.57-1.98-.55-3.01h14.45l.07-2.21ZM107.13,29.4c.03-2.54.36-4.31,1.01-5.32.7-1.03,1.9-1.61,3.14-1.51.55,0,1.1.09,1.61.28.49.21.9.59,1.15,1.06.35.65.58,1.35.69,2.07.18,1.12.28,2.26.29,3.4l-7.9.02ZM99.14,44.17l-7.65-14.72,6.69-10.78h-7.75l-5.68,11.06,6.6,14.44h7.79ZM84.23,9.54h-6.74v34.64h6.74V9.54Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.97f544176c5c5ad515b6370d53d061b1.svg";